import { render, staticRenderFns } from "./CreateManualLprEntry.vue?vue&type=template&id=54b71c02&"
import script from "./CreateManualLprEntry.vue?vue&type=script&lang=js&"
export * from "./CreateManualLprEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports